export default __webpack_public_path__ + "static/media/double.2f186709.jpg";